import { AxiosInstance } from 'axios'
import { IJsonApiSerializer, IJsonResource, IJsonResponse } from '../JsonApiSerializer'

class DirectReservationService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public getDataFromJson(JsonData) {
    const data = this.serializer.parseResourceData(JsonData, JsonData.data)
    const pagination = { ...JsonData.meta }

    return { data, pagination }
  }

  public async createDirectReservation(params) {
    const { data } = await this.httpClient.post(`/agent/api/direct_reservations`, { ...params })
    const direct_reservation = this.serializer.parseResourceData(
      data.direct_reservation,
      data.direct_reservation.data
    )
    return { direct_reservation, flush: data.direct_reservation.flush }
  }

  // ガイドアサイン-直接予約時にエージェントに紐づくガイドを取得する
  public async getReservationGuides(id) {
    const { data } = await this.httpClient.get(
      `/api/direct_reservations/${id}/guide_assigns/direct_reservation_guides`
    )
    const guides = this.serializer.parseResourceData(data.guides.users, data.guides.users.data)
    const guide_calendars = data.guide_calendars
      ? this.serializer.parseResourceData(data.guide_calendars, data.guide_calendars.data)
      : []
    const pagination = data.guides.users.meta
    return { guides, pagination, guide_calendars }
  }

  // ガイドアサイン 直接予約からエージェントとガイドの会話を開始
  public async createGuideConversation(params) {
    const {
      data,
    } = await this.httpClient.post(
      `/api/direct_reservations/${params.id}/guide_assigns/direct_reservation_create_guide_conversation`,
      { ...params.params }
    )
    return { conversationId: data.conversation_id }
  }

  // 直接予約からガイドアサイン
  public async reservationGuideAssign(params) {
    const {
      data,
    } = await this.httpClient.put(
      `/api/direct_reservations/${params.id}/guide_assigns/direct_reservation_assign`,
      { ...params.params }
    )
    const { flush } = data.direct_reservation
    const reservation = this.serializer.parseResourceData(
      data.direct_reservation,
      data.direct_reservation.data
    )

    return { flush }
  }
  // 直接予約からガイドアサイン解除
  public async reservationGuideUnassign(params) {
    const {
      data,
    } = await this.httpClient.put(
      `/api/direct_reservations/${params.id}/guide_assigns/direct_reservation_unassign`,
      { ...params.params }
    )
    const { flush } = data.direct_reservation
    const reservation = this.serializer.parseResourceData(
      data.direct_reservation,
      data.direct_reservation.data
    )

    return { flush }
  }

  // 会話情報を取得する
  public async getReservationMessages(params) {
    const { data } = await this.httpClient.get('/api/messages', { params })
    return { data }
  }

  public async deleteDirectReservation(id) {
    const { data } = await this.httpClient.delete(`/agent/api/direct_reservations/${id}`)
    return { flush: data.flush }
  }
}

export default DirectReservationService
